import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";

const LineGraph = ({ title, color, type, legendName, xdata, ydata }) => {
  const [data, setData] = useState({
    labels: xdata,
    datasets: [
      {
        label: legendName,
        data: ydata, //[0, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        // backgroundColor: "#0070d2",
        borderColor: color,
        pointRadius: 0,
        backgroundColor: color,
      },
    ],
  });
  //   const [graphData, setGraphData] = {
  //     "Oct 2023": 0,
  //     "Nov 2023": 0,
  //     "Dec 2023": 0,
  //     "Jan 2024": 0,
  //     "Feb 2024": 0,
  //     "Mar 2024": 0,
  //     "Apr 2024": 0,
  //     "May 2024": 0,
  //     "Jun 2024": 0,
  //     "Jul 2024": 0,
  //     "Aug 2024": 45,
  //     "Sep 2024": 21,
  //   };
  //   for (const key in graphData) {
  //     dates.push(convertDateFormat(key));
  //     formatData.push(graphData[key]);
  //   }
  function convertDateFormat(dateString) {
    // Split the input string by space to separate the month and year
    const [month, year] = dateString.split(" ");

    // Extract the last two digits of the year
    const yearShort = year.slice(-2);

    // Return the formatted string
    return `${month},${yearShort}`;
  }
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    let floatedValue = parseFloat(num);
    return floatedValue.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const options = {
    maintainAspectRatio: false,

    responsive: true,
    interaction: {
      intersect: true,
      mode: "index",
    },
    scales: {
      y: {
        ticks: {
          callback: function (value, index, values) {
            if (type === "money") {
              return formatToIndianRupees(value);
            }
            return `${value}%`; // Add a dollar sign and format to two decimal places
          },
          font: {
            size: 12, // Adjust font size to your preference (in pixels)
          },
        },
        grid: {
          borderColor: "rgba(0, 0, 0, 0.1)", // Default border color for grid lines
          borderWidth: 1, // Default grid line width
          color: (context) => {
            return context.tick.value === 0 ? "#a0a0a0" : "#f0f0f0"; // Make the 0 line black and others lighter
          },
          lineWidth: (context) => {
            return context.tick.value === 0 ? 2 : 1; // Make the 0 line thicker
          },
        },
        suggestedMin: 0,
        beginAtZero: true,
        stacked: false,

        title: {
          display: true,

          font: "Inter",
          style: "none", // Label for the y-axis
        },
      },

      x: {
        stacked: true,
        ticks: {
          font: {
            size: 9, // Adjust font size to your preference (in pixels)
          },
        },

        grid: {
          display: false,
        },
      },
      // y: {
      //   stacked: true,
      //   grid: {
      //     display: false,
      //   },
      //   title: {
      //     display: true,
      //     text: "Amount ($)",
      //     font: "Inter",
      //     style: "none", // Label for the y-axis
      //   },
      // },
    },
    plugins: {
      tooltip: {
        backgroundColor: "#656565",
        boxPadding: 7,
        padding: 15,
        cornerRadius: 4,
        bodyColor: "white",
        caretSize: 0,
        bodyFont: {
          size: 12,
          lineHeight: 2,
          weight: "normal",
        },
      },
      layout: {
        padding: {
          bottom: 100, // Increase the top padding to create space between legend and graph
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          boxWidth: 8, // Width of the colored box
          boxHeight: 8,
          // Use data point style as legend icon
          color: "#637381", // Text color
        },
      },
    },
  };

  useEffect(() => {
    setData({
      ...data,
      labels: xdata,
      datasets: [{ ...data.datasets[0], data: ydata }],
    });
  }, [xdata]);

  return (
    <div className=" mt-[28px]">
      <p className="ml-[15px] my-4 text-xs font-bold">{title}</p>
      <div className=" ">
        <Line data={data} options={options} height={"290px"} width={"320px"} />
      </div>
    </div>
  );
};

export default LineGraph;
